import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const MYPRICE_LOGIN_BANNER_CLICKED = 'MYPRICE_LOGIN_BANNER_CLICKED';
export const MYPRICE_LOGIN_BANNER_CLICKED_VERSION = '1.0';

export type MyPriceLoginBannerClickedPayload = {
  searchId: string;
};

export type MyPriceLoginBannerClickedParams = {
  searchParams: SearchParams;
};

export const createMyPriceLoginBannerClickedPayload = ({
  searchParams,
}: MyPriceLoginBannerClickedParams): MyPriceLoginBannerClickedPayload => {
  const searchId = searchParams[URLParameters.SEARCH_ID];

  return {
    searchId,
  };
};
